export const SETUP_MODULES_URL = '/api/v1/student/module/setup'
export const KEEP_TRAIL_URL = `/api/v1/student/trail/keepTrail/`
export const LIST_TRAIL_URL = `/api/v1/student/trail?`


